import React, { useEffect } from "react";
import ReactSelect from "react-select";
import { useNavigate } from "react-router-dom";
import { Badge } from "../../../components/micro/input";
import Action from "../../../components/common/Action";
import DebounceSearch from "../../../components/common/DebounceSearch";
import CustomTable from "../../../components/customTable/CustomTable";
import { useDispatch, useSelector } from "react-redux";
import { getTechnicianList } from "../../../redux/service/slice";
import RippleLoader from "../../../components/RippleLoader/RippleLoader";

const Status = [
  { id: 1, value: "on-going", label: "On-Going" },
  { id: 2, value: "completed", label: "Completed" },
];

const tabs = [
  { label: "All", value: "all" },
  { label: "On-Going", value: "on-going" },
  { label: "Completed", value: "completed" },
];

const RecurringRequest = ({
  setSearchValue,
  searchValue,
  setPageLimit,
  pageLimit,
  setPageCount,
  pageCount,
  setActiveTabReccuring,
  activeTabReccuring,
  technician,
  setTechnician,
  selectedStatus,
  setSelectedStatus,
  getSchedulingListData,
  loading,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Selector
  const { techniciansList } = useSelector((store) => ({
    techniciansList: store?.technicianData?.getTechnicianListStatus?.data,
  }));

  // Technician list api
  useEffect(() => {
    dispatch(
      getTechnicianList({
        pageLimit: "all",
      })
    );
  }, [dispatch]);

  const techniciansOptions = (techniciansList?.data || techniciansList)?.map(
    (technicians) => ({
      value: technicians.id,
      label: technicians.full_name,
    })
  );
  const handleTechnicianChange = (selectedOption) => {
    setTechnician(selectedOption);
  };

  const ColumnHeaders = () => (
    <>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <span>No.</span>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <span>Company</span>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <span>No. Outlets</span>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <span>Total Count</span>
      </th>

      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <span>Count left</span>
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Technician
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <span>Status </span>
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Cycle Duration
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Expiry Date
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Action
      </th>
    </>
  );

  const DataRows = () => (
    <>
      {getSchedulingListData?.data?.map((element, index) => (
        <tr
          key={index}
          className="font-Proxima text-[14px] shadow-sm text-mgrey hover:bg-lightprimaryorange"
        >
          <td className="px-5 py-3">
            {(getSchedulingListData?.current_page - 1) *
              getSchedulingListData?.per_page +
              index +
              1}
          </td>
          <td className="px-2 py-3 truncate">
            {element?.company
              ? element?.company
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase())
              : "-"}
          </td>
          <td className="px-5 py-3 truncate">
            {element?.no_of_outlets ?? "-"}
          </td>
          <td className="px-5 py-3 truncate">{element?.totalCount ?? "-"}</td>
          <td className="px-5 py-3 truncate">
            {element?.totalServicesCountLeft ?? "-"}
          </td>
          <td className="px-2 py-3 truncate">
            {element?.technicians
              ? element?.technicians
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase())
              : "-"}
          </td>
          <td className="px-2 py-3">
            <div className="flex justify-start">
              <Badge
                className={`capitalize ${
                  element?.recurring_status === "completed"
                    ? "bg-bgGreen text-white "
                    : element?.recurring_status === "on-going"
                    ? "border-borderGrey text-black"
                    : "border-0"
                }`}
                value={
                  element?.recurring_status === "completed"
                    ? "Completed"
                    : element?.recurring_status === "on-going"
                    ? "On-Going"
                    : "-"
                }
              />
            </div>
          </td>
          <td className="px-5 py-3">{element?.cycle_duration || "-"}</td>
          <td className="px-2 py-3">{element?.expiry_Date || "-"}</td>
          <td className="flex px-2 py-3">
            <Action
              optionList={
                <>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                    onClick={() =>
                      navigate("/view-schedule", {
                        state: { schedule: element },
                      })
                    }
                  >
                    View
                  </li>
                  <li className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer">
                    Cancel
                  </li>
                </>
              }
            />
          </td>
        </tr>
      ))}
    </>
  );
  return (
    <>
      <div>
        <div>
          <div className="flex justify-end mt-2">
            {tabs.map((tab) => (
              <button
                key={tab.label}
                className={`py-2 w-full font-normal mb-5 h-full px-4 uppercase text-[14px] border-b-2 transition duration-300 font-Proxima ${
                  activeTabReccuring === tab.value
                    ? "border-themeBtn text-themeBtn"
                    : "border-transparent text-textSecondary hover:text-themeBtn hover:border-theme text-gray-dark"
                }`}
                onClick={() => setActiveTabReccuring(tab.value)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
        <div className="flex items-center space-x-3">
          <ReactSelect
            className={"w-full max-w-52 text-black p-0 font-Proxima"}
            id="technician"
            placeholder="Technician"
            options={techniciansOptions}
            isClearable={true}
            getOptionValue={(option) => option?.value}
            getOptionLabel={(option) => option?.label}
            value={technician}
            onChange={handleTechnicianChange}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: technician ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "&:active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />
          <ReactSelect
            className={"w-full max-w-52 text-black p-0 font-Proxima"}
            id="status"
            placeholder="Status"
            options={Status}
            isClearable={true}
            value={selectedStatus}
            onChange={(e) => {
              setSelectedStatus(e);
            }}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: selectedStatus ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "& :active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />
          <DebounceSearch
            className="full-width"
            search={searchValue}
            handleChange={setSearchValue}
            placeholder={"Search..."}
          />
        </div>
        {!getSchedulingListData || loading ? (
          <RippleLoader />
        ) : (
          <div className="w-full bg-white shadow rounded-lg mt-5 ">
            <CustomTable
              overflowVisibleLg={true}
              columnHeaders={<ColumnHeaders />}
              dataRows={<DataRows />}
              data={getSchedulingListData}
              loading={loading}
              showPagination={true}
              setPaginationCurrentLimit={setPageLimit}
              paginationCurrentLimit={pageLimit}
              current={pageCount}
              total={getSchedulingListData?.total}
              paginationData={(crPage) => setPageCount(crPage)}
              lastPage={Math.ceil(getSchedulingListData?.total / pageLimit)}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default RecurringRequest;
